export const EURO_ONLY = [
    2, 24, 27, 40, 41, 56, 63, 66, 82, 84, 85, 94, 108, 113, 114, 115, 126, 144, 149, 165, 166, 173,
    177, 180, 192, 196, 197, 228, 230, 233, 236, 237, 239, 240, 241, 245, 254,
]
